// import { useProjectStore } from '../../stores/projectStore';
import SearchBar from "@/components/SearchBar";
import ProjetDropdown from "@/components/myProjectsComp/ProjetDropdown";
import { useProjectStore } from "@/stores/projectStore";
import IconButton from "@/components/IconButton";
import { BellIcon, Cog6ToothIcon, StarIcon } from "@heroicons/react/24/outline";

import AddProjectModal from "@/components/modals/AddProjectModal";

const MyProjectsHeader = () => {
  const { projects } = useProjectStore();

  return (
    <div className="flex items-center justify-between px-4 py-7  bg-white w-full	border-b">
      {/* Left Section */}
      <div className="flex items-center space-x-6">
        <SearchBar />
        <ProjetDropdown title={"Projetcs en cours"} options={projects} />
        <ProjetDropdown title={"Brouillon"} options={projects} />
      </div>

      {/* Right Section*/}

      <div className="flex items-center space-x-4">
        <AddProjectModal />
        <IconButton
          icon={<StarIcon className="h-7 w-7 text-gray-600" />}
          action={() => {}}
        />
        <IconButton
          icon={<BellIcon className="h-7 w-7 text-gray-600" />}
          action={() => {}}
        />
        <IconButton
          icon={<Cog6ToothIcon className="h-7 w-7 text-gray-600" />}
          action={() => {}}
        />
      </div>
    </div>
  );
};

export default MyProjectsHeader;
